<div class="sidebar-wrapper" [ngClass]="{ 'sidebar-collapsed': isSidebarCollapsed, 'sidebar-mobile-open': isMobileOpen }">

  <!-- Panel 1 — Brand / Logo with Collapse Tab -->
  <div class="sidebar-panel sidebar-brand-panel">
    <img
      *ngIf="isSidebarCollapsed"
      [routerLink]="'/dashboard'"
      src="/logo.png"
      class="sidebar-logo-collapsed"
      alt="Conversely"
      onerror="this.src='/favicon.ico'"
    />
    <img
      *ngIf="!isSidebarCollapsed"
      (click)="goToDashboard()"
      src="/assets/images/logo.svg"
      class="sidebar-logo-img"
      alt="Conversely"
    />
    
    <!-- Collapse Tab (integrated) -->
    <button 
      type="button"
      class="sidebar-collapse-tab"
      (click)="toggleSidebar()"
      [attr.aria-expanded]="!isSidebarCollapsed"
      [title]="isSidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'"
      aria-label="Toggle sidebar"
    >
      <i class="fa-solid fa-chevron-left"></i>
    </button>
  </div>

  <!-- Panel 2 — Menu Items -->
  <nav class="sidebar-panel sidebar-nav-panel">
    <span *ngIf="!isSidebarCollapsed" class="nav-section-label">Menu</span>
    <ul>
      <ng-container *ngFor="let item of menuItems">
        <li class="sidebar-menu-item">
          <a
            [routerLink]="item.routerLink"
            class="sidebar-item"
            routerLinkActive="menu-item-active"
            [ngClass]="{
              'has-children': item.children,
              'menu-item-active': item.isOpen
            }"
            (click)="toggleMenuItem(item)"
          >
            <span class="sidebar-item-icon"><i [class]="item.icon"></i></span>
            <span class="sidebar-item-text">{{ item.label }}</span>
            <i
              *ngIf="item.children && !isSidebarCollapsed"
              class="fas fa-chevron-down sidebar-item-arrow"
              [ngClass]="{ rotated: item.isOpen }"
            ></i>
          </a>
          <ul
            *ngIf="item.children && !isSidebarCollapsed && item.isOpen"
            class="sidebar-submenu"
          >
            <li *ngFor="let child of item.children">
              <a href="#" class="sidebar-item sidebar-subitem">
                <span class="sidebar-item-icon"><i [class]="child.icon"></i></span>
                <span class="sidebar-item-text">{{ child.label }}</span>
              </a>
            </li>
          </ul>
        </li>
      </ng-container>
    </ul>

    <!-- Organization admin menu item (org admins only) -->
    <a
      *ngIf="isOrgAdmin && !isSidebarCollapsed"
      routerLink="/organization"
      class="sidebar-item org-admin-item"
      routerLinkActive="menu-item-active"
    >
      <span class="sidebar-item-icon"><i class="fa-solid fa-building"></i></span>
      <span class="sidebar-item-text">Organization</span>
    </a>
    <a
      *ngIf="isOrgAdmin && isSidebarCollapsed"
      routerLink="/organization"
      class="sidebar-item"
      routerLinkActive="menu-item-active"
      title="Organization"
    >
      <span class="sidebar-item-icon"><i class="fa-solid fa-building"></i></span>
    </a>

    <button
      *ngIf="!isSidebarCollapsed && !hasConnectedCrm"
      type="button"
      class="crm-connect-cta sidebar-item"
      (click)="goToCrmSettings()"
      aria-label="Connect to CRM"
      title="Connect Salesforce, Zoho, HubSpot, or Pipedrive"
    >
      <span class="sidebar-item-icon crm-cta-icon" aria-hidden="true">
        <i class="fa-solid fa-plug-circle-bolt"></i>
      </span>

      <span class="crm-cta-content">
        <span class="sidebar-item-text crm-cta-title">Connect to CRM</span>
        <span class="sidebar-crm-logos-inline">
          <i class="fa-brands fa-salesforce sf-icon" title="Salesforce"></i>
          <span class="zh-icon" title="Zoho"></span>
          <i class="fa-brands fa-hubspot hs-icon" title="HubSpot"></i>
          <!-- <span class="pd-icon" title="Pipedrive (coming soon)"></span> -->
        </span>
      </span>

      <span class="crm-cta-attention" title="Attention needed">!</span>
    </button>
  </nav>

  <!-- Panel 3 — Bottom: Hover‑reveal actions + Profile -->
  <div class="sidebar-bottom-area">

    <!-- Settings & Logout – hidden until sidebar hover -->
    <div class="sidebar-panel sidebar-system-panel">
      <ul>
        <li class="sidebar-menu-item" *ngIf="hasPendingInvite">
          <a routerLink="/accept-invite" class="sidebar-item" title="Pending Invites">
            <span class="sidebar-item-icon notification-bell">
              <i class="fa-solid fa-bell"></i>
              <span class="notification-dot"></span>
            </span>
            <span class="sidebar-item-text">Invites</span>
          </a>
        </li>
        <li class="sidebar-menu-item">
          <a routerLink="/settings" class="sidebar-item" routerLinkActive="menu-item-active">
            <span class="sidebar-item-icon"><i class="fa-solid fa-gear"></i></span>
            <span class="sidebar-item-text">Settings</span>
          </a>
        </li>
        <li class="sidebar-menu-item" (click)="logout()">
          <a class="sidebar-item">
            <span class="sidebar-item-icon"><i class="fa-solid fa-power-off"></i></span>
            <span class="sidebar-item-text">Logout</span>
          </a>
        </li>
      </ul>
    </div>

    <!-- License status indicator (subtle, shows only when expiring soon or expired) -->
    <div class="license-status-indicator"
         *ngIf="licenseStatusLabel"
         [class.lsi--warning]="licenseStatusLevel === 'warning'"
         [class.lsi--danger]="licenseStatusLevel === 'danger'"
         (click)="openSettings()">
      <span class="lsi-dot"></span>
      <span class="lsi-text" *ngIf="!isSidebarCollapsed">{{ licenseStatusLabel }}</span>
    </div>

    <!-- Profile card – always visible -->
    <div class="sidebar-panel sidebar-profile-panel">
      <span class="nav_image">
        <i class="fa-solid fa-circle-user default-avatar"></i>
        <img
          *ngIf="avatarUrl"
          [src]="avatarUrl"
          alt="Profile Picture"
          class="profile-picture"
          (error)="onImageError()"
        />
      </span>
      <div class="data_text">
        <span *ngIf="name" class="name">{{ name }}</span>
        <span class="email">{{ userName }}</span>
      </div>
    </div>
  </div>
</div>
